import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedLink } from "../../hooks/useLocalizedLink";

function MobileMenu({ isOpen, onClose }) {
  const [activeMenu, setActiveMenu] = useState(null);
  const menuRefs = useRef({});
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();

  // Toggle dropdown menu
  const toggleMenu = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  // Apply height animation when activeMenu changes
  useEffect(() => {
    Object.keys(menuRefs.current).forEach((key) => {
      const submenu = menuRefs.current[key];
      if (submenu) {
        submenu.style.height =
          activeMenu === Number(key) ? `${submenu.scrollHeight}px` : "0px";
      }
    });
  }, [activeMenu]);

  return (
    <div
      className={`th-menu-wrapper onepage-nav ${
        isOpen ? "th-body-visible" : ""
      }`}
      style={{ visibility: isOpen ? "visible" : "hidden" }}
    >
      <div className="th-menu-area text-center">
        <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
          <i className="fal fa-times" />
        </button>

        <div className="mobile-logo">
          <Link to={getLocalizedPath("/")}>
            <img
              src="/assets/img/logo-haseki.png"
              alt="Haseki Sultan Kız Yurdu"
              className="img-fluid"
              style={{ maxWidth: "240px", height: "auto" }}
            />
          </Link>
        </div>

        <div className="th-mobile-menu">
          <ul>
            {/* Home */}
            <li>
              <Link to={getLocalizedPath("/")} onClick={onClose}>
                {t("nav.home")}
              </Link>
            </li>

            {/* Services */}
            <li
              className={`menu-item-has-children th-item-has-children ${
                activeMenu === 1 ? "th-active" : ""
              }`}
            >
              <Link to="#" onClick={() => toggleMenu(1)}>
                {t("nav.services")}
              </Link>
              <ul
                ref={(el) => (menuRefs.current[1] = el)}
                className="th-submenu"
                style={{
                  height: "0px",
                  overflow: "hidden",
                  transition: "height 0.3s ease-in-out",
                }}
              >
                <li>
                  <Link
                    to={getLocalizedPath("/service/single-room")}
                    onClick={onClose}
                  >
                    {t("nav.singleRoom")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/double-room")}
                    onClick={onClose}
                  >
                    {t("nav.doubleRoom")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/triple-room")}
                    onClick={onClose}
                  >
                    {t("nav.tripleRoom")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/quad-room")}
                    onClick={onClose}
                  >
                    {t("nav.quadRoom")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/six-room")}
                    onClick={onClose}
                  >
                    {t("nav.sixRoom")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/social-areas")}
                    onClick={onClose}
                  >
                    {t("nav.socialAreas")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/transportation")}
                    onClick={onClose}
                  >
                    {t("nav.transportation")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/nearby-places")}
                    onClick={onClose}
                  >
                    {t("nav.nearbyPlaces")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={getLocalizedPath("/service/nearby-universities")}
                    onClick={onClose}
                  >
                    {t("nav.nearbyUniversities")}
                  </Link>
                </li>
                <li>
                  <Link to={getLocalizedPath("/gallery")} onClick={onClose}>
                    {t("nav.generalPhotos")}
                  </Link>
                </li>
              </ul>
            </li>

            {/* Online Registration */}
            <li>
              <Link to={getLocalizedPath("/contact")} onClick={onClose}>
                {t("nav.onlineRegistration")}
              </Link>
            </li>

            {/* About */}
            <li>
              <Link to={getLocalizedPath("/about")} onClick={onClose}>
                {t("nav.about")}
              </Link>
            </li>

            {/* Contact */}
            <li>
              <Link to={getLocalizedPath("/contact")} onClick={onClose}>
                {t("nav.contact")}
              </Link>
            </li>

          </ul>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
